// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"EllipsisText_ellipsis__1U6jr"};